<template>
  <div class="love-center">
    <div class="love-center-wrapper">
      <div class="header">
        <button @click="goback" class="goback"></button>
        <div class="title">我的爱心币</div>
        <router-link class="home" to="/home"></router-link>
      </div>
      <div class="can-prepaid">
        <div class="title">可使用爱心币</div>
        <div class="prepaid-intro">
          <div class="money-balances">
            <em>{{loveAccount.account_love}}</em>
          </div>
          <i>爱心币仅用于<br>购买【消费帮扶】商品!</i>
        </div>
      </div>
    </div>
    <!-- swipeable animated -->
    <van-tabs
      :border="false"
      :ellipsis="false"
      background="#f8f8f8"
      color="#333"
      line-height="4px"
      line-width="48"
      sticky
      title-active-color="#333"
      title-inactive-color="#fff"
      v-model="current"
    >
      <van-tab :key="index" :title="nav.title" class="nav-tab" v-for="(nav, index) in navList">
        <div class="nav-container">
          <component :is="componentId"></component>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { Tab, Tabs } from 'vant'
import ChargeRecords from '../components/loveCenter/ChargeRecords'
import UnavailableRecords from '../components/loveCenter/UnavailableRecords'
export default {
  name: 'loveCenter',
  components: {
    VanTab: Tab,
    VanTabs: Tabs,
    ChargeRecords,
    UnavailableRecords
  },
  data () {
    return {
      loveAccount: '',
      sticky: false,
      current: 0,
      offsetTop: 0,
      componentId: ChargeRecords,
      navList: [
        // { title: '在途爱心币', name: 'UnavailableRecords' },
        { title: '爱心币明细', name: 'ChargeRecords' }
      ]
    }
  },
  watch: {
    current (newVal) {
      if (newVal === 0) {
        this.componentId = UnavailableRecords
      } else if (newVal === 1) {
        this.componentId = ChargeRecords
      }
    }
  },
  created () {
    this.getLoveAccount()
  },
  methods: {

    goback () {
      this.$router.back()
    },
    switchTab (i) {
      this.current = i
    },
    jumpDetails () {
      // console.log('跳到详情')
    },
    // 获取爱心币数量
    async getLoveAccount () {
      const res = await this.$axios.get('api/member/account_love')
      if (res.status === 200) {
        const { code, data, msg } = res.data
        if (code === 0) {
          this.loveAccount = data
        } else {
          this.$toast(msg)
        }
      }
    },
    scrollHandler (e) {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      this.offsetTop = this.$refs.nav.offsetTop
      // console.log(this.offsetTop)
      if (scrollTop > this.offsetTop - 10) {
        this.sticky = true
      } else {
        this.sticky = false
      }
    }
  }
}
</script>
<style lang="less">
.van-tabs--line .van-tabs__wrap {
  height: 1rem;
}
.love-center .van-tab{
  padding: 0 .2rem;
}
.love-center .van-tabs__nav{
  background: #f8f8f8 !important;
}
.love-center .van-tab span {
  font-size: .28rem;
  height: 100% ;
  display: flex;
  align-items: center ;
  justify-content: flex-start;
  font-weight: bold ;
}
.love-center .van-tabs__line {
  display: none;
}
</style>
<style lang="less" scoped>
.love-center {
  .love-center-wrapper {
    // background-color: #fe4f3e;
    background-color: #2D2D3E;
    padding: 0 0.28rem;
    .header {
      width: 100%;
      .flex-between;
      font-size: 0.28rem;
      color: #fff;
      padding: 0.2rem 0 0.27rem;
      .goback,
      .home {
        width: 0.6rem;
        height: 0.6rem;
        background: url("../assets/img/back.png") center no-repeat;
        background-size: 100%;
      }
      .home {
        background: url("../assets/img/back-home.png") center no-repeat;
        background-size: 100%;
      }
    }
    .can-prepaid {
      color: #fff;
      font-size: 0.28rem;
      padding-bottom: 0.5rem;
      // border-bottom: 0.5px solid #ff8f8f;
      .prepaid-intro {
        .flex-between;
        .money-balances {
          em {
            font-size: 0.88rem;
            font-weight: bold;
            padding-right: 0.1rem;
            color: #F0D2A6;
          }
        }
        .go-prepaid {
          padding: 0.2rem;
          font-size: 0.26rem;
          color: #F0D2A6;
          // background-color: #fff;
          opacity: 1;
          border: 1px solid #f0d2a6;
          border-radius: 43px;
        }
        i{
          text-align: right;
        }
      }
    }
  }
}
</style>
